import styled from "styled-components";
import React from "react";

const CustomRow = (props) => {
  return <Row {...props}>{props.children}</Row>;
};

export default CustomRow;

const Row = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: stretch; /* The cells are stretched to the height of the highest one */
  
  &:not(:last-child) {
    border-bottom: 1px solid var(--surface-300);
  }
  
  &:last-child {
    border-bottom: none;
    border-bottom-right-radius: 8px;
    & > div[data-variant="header"] {
      border-bottom-left-radius: 8px;
    }
  }
`;
